import { Text } from '@/components/ui/Text';
import type { SigningReturnOutcome } from '@/lib/contracts/signing-return-message';
import type { SigningReturnRelay } from './relay-signing-return';

/** Handover §5 copy. Static: the page never claims a signature and reads no data. */
const OUTCOME_HEADING: Record<SigningReturnOutcome, string> = {
  done: 'Finished — you can close this',
  declined: 'Declined',
  closed: 'Closed — you can finish later',
};

export interface SigningReturnAppProps {
  outcome: SigningReturnOutcome;
  /** What the pre-render relay managed to reach. */
  relay: SigningReturnRelay;
}

export function SigningReturnApp({ outcome, relay }: SigningReturnAppProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-4 text-text">
      <div className="w-full max-w-md space-y-3 text-center">
        <Text variant="headline-sm" as="h1">
          {OUTCOME_HEADING[outcome]}
        </Text>
        {/* Framed, the host closes the dialog. In the fallback tab (D-20: no relay) or AC-4.6's
            unreachable case, the user is told they can close it; the host refreshes by polling. */}
        {relay !== 'framed' && (
          <Text variant="body-md" color="muted">
            You can close this tab/window
          </Text>
        )}
      </div>
    </div>
  );
}
